import React, {Component} from 'react'
import Base from '../BaseComponent'
import conf from '../../_conf';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel";

//import settings from '../../data/settings';

// global map styles
const defaultStyle = require("./styles.json");


class MiniMap extends Component {

shouldComponentUpdate () {

	return false;

}

  render () {

  	//console.log('MAP',this.props);

  	let settings = conf.get();
  	let marker = (this.props.markerColour != "") ? this.props.markerColour : '#000000'
  	// SVG marker icon
  	let icon = {
	    path: "M-10,0a10,10 0 1,0 20,0a10,10 0 1,0 -20,0Z",
	    fillColor: marker,
	    fillOpacity: 1,
	    strokeWeight: 0,
	    scale: 1
	}

	/*
		Size:
		size: {width: 60, height: 100}
		
	*/

	if(this.props.icon) icon = {...icon,...this.props.icon};

	const height = this.props.height || '100%';
	const scrollWheel = this.props.scrollWheel || false;
	let zoom = this.props.zoom || 15;
	
	const defaultUI = this.props.defaultUI || true;

	//position object from props
	const latlng = {
		lat: parseFloat(''+this.props.lat),
		lng: parseFloat(''+this.props.lng)
	}

	const mapStyles = this.props.styles || defaultStyle;
  	
  	let markers = this.props.markers || [{
  		lat : this.props.lat,
  		lng : this.props.lng
  	}];



  	const MyMapComponent = withScriptjs(withGoogleMap((props) =>
		  <GoogleMap

		    defaultZoom={zoom}
		    defaultCenter={latlng}
		    defaultOptions={{ scrollwheel:scrollWheel, styles: mapStyles, disableDefaultUI: !defaultUI}}>
		    	
		    	{markers.map((m,ix)=>{
		    		let markerLatLng = {
						lat: parseFloat(''+m.lat),
						lng: parseFloat(''+m.lng)
					}

					let props = {icon:icon,position:markerLatLng,...m};

					if(!m.content) return (<Marker {...props} />)

					let modifier = m.modifier || 'default';
						
					return (<MarkerWithLabel
      position={props.position}
      icon={{
	    path: "M-10,0a10,10 0 1,0 20,0a10,10 0 1,0 -20,0Z",
	    fillColor: '#000000',
	    fillOpacity: 0,
	    strokeWeight: 0,
	    scale: 0
	}}
      labelAnchor={new window.google.maps.Point(0, 0)}
      labelStyle={null}
      labelClass={'Map-marker Map-marker--'+modifier}
    >
      <div className="Map-marker-content">{m.content}</div>
    </MarkerWithLabel>);

		    		
		    	})}
		  </GoogleMap>
		))

  	let passProps = {...this.props};
  	if(passProps.markerColour) delete passProps.markerColour;

    return (

      <Base {...passProps} className={this.props.className || "MiniMap"}>

      	<MyMapComponent
			  isMarkerShown
			  googleMapURL={"https://maps.googleapis.com/maps/api/js?key="+settings.GOOGLE_MAPS_API_KEY+"&v=3.exp&libraries=geometry,drawing,places"}
			  loadingElement={<div style={{ width: '100%', height: `100%` }} />}
			  containerElement={<div style={{ width: '100%', height: height }} />}
			  mapElement={<div style={{ width: '100%', height: `100%` }} />}
			/>
        
      </Base>
    )
  }
}

export default MiniMap



// WEBPACK FOOTER //
// ./src/js/_core/components/Map/Map.jsx